<template>
  <div>
    <SpFilterForm :model="formData" @onSearch="onSearch" @onReset="onReset">
      <SpFilterFormItem prop="times" label="">
        <el-date-picker v-model="formData.times" type="datetimerange" format="yyyy-MM-dd HH:mm:ss"
          value-format="timestamp" start-placeholder="开始日期" end-placeholder="结束日期" />
      </SpFilterFormItem>
      <SpFilterFormItem prop="relItems" label="">
        <el-button @click="handleGoodsDialogShow">
          {{ relItems.length > 0 ? `已选择${relItems.length}个商品` : '选择商品' }}
          <i v-if="relItems.length > 0" class="el-icon-circle-close" @click="clearGoods"></i>
          <i v-else class="el-icon-circle-plus"></i></el-button>
      </SpFilterFormItem>
      <SpFilterFormItem prop="relItems" label="">
        <el-button type="primary" @click="exportData">导出预警记录明细</el-button>
      </SpFilterFormItem>
    </SpFilterForm>
    <SpFinder no-selection ref="finder" :setting="setting" row-actions-width="250" :row-actions-align="'left'"
      :fixed-row-action="true" :url="listsUrl" :hooks="{
        beforeSearch: beforeSearch,
        afterSearch: afterSearch
      }" :split-count="5">
    </SpFinder>
    <router-view></router-view>
  </div>
</template>

<script>
import { createSetting } from '@shopex/finder'
import { useDialog } from '@shopex/finder'
import { listsUrl, setSecureSpuOrderOpenStatus, secureSpuOderSpuWarningLists } from './api'

export default {
  components: {
  },
  data() {
    return {
      listsUrl,
      setting: createSetting({
        columns: [
          { name: '预警商品', key: 'item_name' },
          { name: '首次预警时间', key: 'first_warning_time' },
          {
            name: '最后预警时间', key: 'last_warning_time',
          },
          {
            name: '拦截下单', key: 'status',
            render: (h, { row }) => {

              return <el-select v-model={row.open_status} placeholder="请选择" on-change={(value) => this.onStatusChange(row, value)}>
                <el-option
                  label="拦截中"
                  value={true}>
                </el-option>
                <el-option
                  label="未拦截"
                  value={false}>
                </el-option>
              </el-select>
              // return <el-switch
              //   v-model={row.open_status}
              //   on-change={(value) => this.onStatusChange(row, value)}
              //   active-color="#13ce66"
              //   inactive-color="#f0f2f5">
              // </el-switch>
            }
          },
          {
            name: '预警日志明细', key: 'status',
            render: (h, { row }) => {
              return <el-button type="text" on-click={() => this.viewLog(row)}>查看</el-button>
            }
          },
        ],
        actions: []
      }),
      formData: {
        times: []
      },
      relItems: [],
      // 搜索参数
      searchParams: {}
    }
  },
  methods: {
    async handleGoodsDialogShow() {
      const { data } = await this.$picker.goodsitem({
        data: this.relItems,
        paramsFieldExclude: ['distributor_id'],
        queryParams: {
          is_sku: false,
        },
        rowKey: 'item_id',
        multiple: true
      })
      this.relItems = data
    },
    // 清空选择商品
    clearGoods(event) {
      // 阻止冒泡
      event.stopPropagation()
      this.relItems = []
    },
    // 查看日志
    viewLog(item) {
      useDialog(null, {
        title: '预警记录',
        width: '50%',
        info: item,
        component: () => import('./comps/log-list.vue'),
        actions: []
      }).then(() => {
      })
    },
    onStatusChange(row, v) {
      setSecureSpuOrderOpenStatus({ goods_id: row.goods_id, open_status: row.open_status }).then(() => {
        this.$message.success('操作成功')
      })
    },
    beforeSearch(params) {
      const goods_id = this.relItems.map(item => item.goods_id)
      var start_time = '', end_time = ''
      if (this.formData.times) {
        start_time = this.formData.times[0] / 1000 || ''
        end_time = this.formData.times[1] / 1000 || ''
      }
      const pamars = {
        ...params,
        goods_id,
        start_time,
        end_time
      }
      this.searchParams = pamars
      return pamars
    },
    // 导出
    exportData() {
      secureSpuOderSpuWarningLists({ ...this.searchParams, is_export: 1 }).then(() => {
        this.$message.success('请到导出列表【安全】选项查看')
      })
    },
    afterSearch(res) {
      const { data } = res.data
      return data
    },
    onSearch() {
      this.$refs.finder.refresh(true)
    },
    onReset() {
      this.relItems = []
      this.$refs.finder.refresh(true)
    },
  }
}
</script>

<style lang="scss" scoped></style>
<style lang="scss">
.sp-finder-hd {
  padding-top: 10px !important;
}

.view-template-dialog {
  .sp-finder-hd {
    display: none;
  }

  .el-dialog__body {
    padding: 0 !important;

    .el-form {
      margin: 0 !important;
    }

    .el-form-item {
      margin-bottom: 0 !important;
    }
  }
}
</style>
